module.exports = __webpack_public_path__ + "media/images/x-42429a25c4c08bae1012aa36b52771a0.svg";